export const getCurrencyFromListing = (listing) => {
  const prices = listing?.prices || [];
  const currency = prices[0] ? prices[0].currency : 'USD';
  return currency;
};
